module.exports = __webpack_public_path__ + "static/media/gal0809-01.4601e570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal0809/gal0809-01.jpg
// module id = 534
// module chunks = 0